import { MenuUpIcon } from './MenuUpIcon';

/**
 * author: Google
 * id A526C6AC-3E29-49D1-91FA-07F95B470626
 * name menu-up
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/menu-up.svg
 * tags
 * - Arrow 
 */
export const ArrowDropUpIcon = MenuUpIcon;
export default ArrowDropUpIcon